import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=0a725e63"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=0a725e63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports